export const PROJECT_MESSAGE = {
  JOIN_COMPLETED: "Join confirmed.\nPlease check on My Page!",
  JOIN_ERROR: "Join failed.",
  JOIN_CANCELLED: "Participation canceled.",
  JOIN_CANCEL_ERROR: "Participation cancellation failed.",
  SHARE_LINK: "Copied to the clipboard.",
  EVENT_JOIN_ERROR:
    "Failed to join the event. Please join the event in the project so you can have a chat with other participants and the manager. If you are dealing with a problem, please contact the CS team.",
};

export const COMMENT_MESSAGE = {
  UNJOINED_USER: "You can leave a comment after joining this edition.",
  COMMENT_ADDED: "Comment added.",
  COMMENT_EDITED: "Comment edited.",
  COMMENT_DELETED: "Comment deleted.",
  REPLY_ADDED: "Reply added.",
  REPLY_EDITED: "Reply edited.",
  REPLY_DELETED: "Reply deleted.",
};
